import React, { useState, useEffect } from "react";
import DataTable from 'react-data-table-component';
import { NavLink } from "react-router-dom"
import { Variables } from "../../Variations/Variations"
import { BiEdit, BiShowAlt, BiHide } from 'react-icons/bi'
import { ToastContainer, toast } from 'react-toastify';
import { AiOutlineClose, AiOutlineCheck, AiOutlineRight } from 'react-icons/ai'

const ListVideos = () => {
    const [videos, setVideos] = useState();
    const columns = [
        {
            name: 'ID',
            selector: row => row.Id,
            sortable: true,

        },
        {
            name: 'Video Name',
            selector: row => row.Title,
            sortable: true,
        },
        {
            name: 'Published',
            selector: row => row.IsPublished ? <AiOutlineCheck /> : <AiOutlineClose />,
            sortable: true,
        },

        {
            name: 'Options',
            selector: row => <div>
                <NavLink to={"/admin/rasha/Video/" + row.Id} className="btn btn-outline-secondary btn-sm" ><BiEdit /></NavLink>
                <button className="btn btn-outline-danger btn-sm ms-2" onClick={() => TooglePublishVideo(row.Id)}>{row.IsPublished ? <BiHide /> : <BiShowAlt />} </button>

            </div>,
        }
    ];

    async function TooglePublishVideo(id) {
        let response = await fetch(
            Variables.API_URL + "Rasha/Video/UpsertPublish/" + id,
            {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    "Access-Control-Allow-Origin": Variables.API_URL,
                },
            }
        );
        let result = await response.json();
        if (response.ok) {
            toast.success(result);
            GetVideo();
        } else {
            toast.error(result);
        }
    }

    async function GetVideo() {
        const URL = Variables.API_URL + "Rasha/Video/Get";
        const response = await fetch(URL)
        if (!response.ok) throw Error("Did Not Receive expected data");
        const listItems = await response.json();
              const flat = (listItems || []).map((x) => ({
        Id: x?.Video?.Id ?? 0,
        Title: x?.Video?.Title ?? "",
        Name: x?.WidgetDetails?.Name ?? "",
        IsPublished: !!x?.Video?.IsPublished,
        _raw: x,
      }));
        setVideos(flat);
    }
    //#region Use Effect 
    useEffect(() => {
        GetVideo();
    }, [])
    //#endregion Use Effect 
    return (
        <div className="rightSide">
            <div className="container-fluid mt-3">
                <div className="row">
                    <div className="col-12">
                        <h2>List Videos</h2>
                        <ul className="portalPath">
                            <li>Home <AiOutlineRight /></li>
                            <li>List Videos</li>
                        </ul>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                        <div className="card">
                            <div className="card-body">
                                <div className="col-12 mb-3 text-end">
                                    
                                        <NavLink to='/admin/rasha/Video/0' className='btn btn-primary'>Add Video</NavLink>
                                        
                                </div>
                                <div className="portalTable">
                                    <DataTable
                                        columns={columns}
                                        data={videos}
                                        pagination />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <ToastContainer position="top-right"
                    autoClose={5000}
                    hideProgressBar={true}
                    newestOnTop={false}
                    closeOnClick />
            </div>
        </div>
    )
}
export default ListVideos;